(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gm-product-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gm-stories')) {
  customElements.define('gm-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.track = this.querySelector('.gm-stories-track');
      if (!this.track || this.dataset.mode === 'grid') return;
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.hover = false;
      const controls = this.querySelector('.gm-stories-controls');
      if (controls) controls.hidden = false;
      this.pause = this.querySelector('[data-pause]');
      if (this.pause && this.dataset.auto === 'true') this.pause.hidden = false;
      this.addEventListener('click', e => {
        if (e.target.closest('[data-next]')) this.move(1);
        if (e.target.closest('[data-prev]')) this.move(-1);
        if (e.target.closest('[data-pause]')) {
          this.paused = !this.paused;
          this.pause.setAttribute('aria-pressed',String(this.paused));
        }
      },opts);
      this.addEventListener('mouseenter',()=>this.hover=true,opts);
      this.addEventListener('mouseleave',()=>this.hover=false,opts);
      this.addEventListener('play',e=>{
        this.querySelectorAll('video').forEach(v=>{if(v!==e.target)v.pause();});
      },{...opts,capture:true});
      this.addEventListener('shopify:block:select',e=>{
        this.paused=true;
        this.pause?.setAttribute('aria-pressed','true');
        const card=e.target.closest('.gm-story');
        if(card)this.track.scrollTo({left:card.offsetLeft-this.track.firstElementChild.offsetLeft,behavior:'instant'});
      },opts);
      this.timer=setInterval(()=>{
        if(this.dataset.auto!=='true'||this.paused||this.hover||this.reduced.matches||document.hidden||this.contains(document.activeElement))return;
        if([...this.querySelectorAll('video')].some(v=>!v.paused))return;
        const rect=this.getBoundingClientRect();
        if(rect.bottom<0||rect.top>innerHeight)return;
        this.move(1);
      },Math.max(3,Number(this.dataset.seconds)||5)*1000);
      this.cleanup=true;
    }
    move(direction) {
      const track=this.track;
      const gap=parseFloat(getComputedStyle(track).gap)||0;
      const step=track.firstElementChild.getBoundingClientRect().width+gap;
      const max=track.scrollWidth-track.clientWidth;
      if(max<=1)return;
      let left=track.scrollLeft+direction*step;
      if(direction>0&&track.scrollLeft>=max-2)left=0;
      if(direction<0&&track.scrollLeft<=1)left=max;
      this.querySelectorAll('video').forEach(v=>v.pause());
      track.scrollTo({left:Math.max(0,Math.min(max,left)),behavior:this.reduced.matches?'instant':'smooth'});
    }
    disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();this.cleanup=false;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
